import React from 'react'

function Loader(props) {
  return (
    <div className={props.full ? `fullLoader` : ``}>
        <div className="text-center">
            <div className="lds-roller">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
        </div>
    </div>
  )
}

export const generarCabeceraHTML = (isEmail = false, data) => {
    const { even_LogoEvento, even_Nombre } = data;
    const urlSeparador = "https://recursos.exportemos.pe/registro-participantes/separador.png";
    const anchoTabla = isEmail ? "700" : "100%";
    const altoFijo = "145"; 

    return `
        <table id="header-generado" border="0" cellpadding="0" cellspacing="0" width="${anchoTabla}" height="${altoFijo}"
            style="width:${isEmail ? '700px' : '100%'}; height:${altoFijo}px; table-layout:auto; background-color:white">
            <tbody>
                <tr style="height:${altoFijo}px;">
                    <td valign="middle" style="height:${altoFijo}px; width:180px; line-height:0;">
                        <img src="${even_LogoEvento}" alt="Logo" style="display:inline-block; max-height:${parseInt(altoFijo) - 20}px; width:auto; height:auto; border:0;">
                    </td>
                    <td align="center" valign="middle"><img src="${urlSeparador}" alt="" ></td>        
                    <td align="center" style="height:${altoFijo}px; padding:20px;">
                        <strong style="font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; font-weight: bold; font-size: 26px; line-height: 1.2; text-align: center; color: #000000; text-shadow: 1px 1px 3px rgba(0,0,0,0.3);">
                            ${even_Nombre || ""}
                        </strong>
                    </td>
                </tr>
            </tbody>
        </table>
    `.replace(/\n/g, '').trim();
};

export default Loader